import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/faxTracker/'
import pathMap from 'src/paths/pathMap'

class FaxTrackerRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.MAN_FAX_TRAC_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.MAN_FAX_TRAC_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.MAN_FAX_TRAC_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.MAN_FAX_TRAC_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default FaxTrackerRoute
